import permissions from './permission-list'

export default [
  {
    path: '/courier-services',
    name: 'courier-services',
    component: () => import('@/views/CourierServices.vue'),
    meta: {
      pageTitle: 'Layanan Kurir',
      resource: permissions.courierService,
      action: 'read',
      navActiveLink: 'courier-services',
      breadcrumb: [
        { text: 'Layanan Kurir', active: true },
      ],
    },
  },
  {
    path: '/courier-services/create',
    name: 'courier-services-create',
    component: () => import('@/views/CourierServiceCreate.vue'),
    meta: {
      pageTitle: 'Buat Layanan Kurir',
      resource: permissions.courierService,
      action: 'manage',
      navActiveLink: 'courier-services',
      breadcrumb: [
        { text: 'Layanan Kurir', to: { name: 'courier-services' } },
        { text: 'Buat', active: true },
      ],
    },
  },
  {
    path: '/courier-services/:id/detail',
    name: 'courier-services-detail',
    component: () => import('@/views/CourierServiceDetail.vue'),
    meta: {
      pageTitle: 'Detail Layanan Kurir',
      resource: permissions.courierService,
      action: 'read',
      navActiveLink: 'courier-services',
      breadcrumb: [
        { text: 'Layanan Kurir', to: { name: 'courier-services' } },
        { text: 'Detail', active: true },
      ],
    },
  },
  {
    path: '/courier-services/:id/edit',
    name: 'courier-services-edit',
    component: () => import('@/views/CourierServiceEdit.vue'),
    meta: {
      pageTitle: 'Edit Layanan Kurir',
      resource: permissions.courierService,
      action: 'manage',
      navActiveLink: 'courier-services',
      breadcrumb: [
        { text: 'Layanan Kurir', to: { name: 'courier-services' } },
        { text: 'Edit', active: true },
      ],
    },
  },
]
